import React from 'react'

function Invoices() {
  return (
    <div>Invoices</div>
  )
}

export default Invoices